import Pagination, {
  Page
} from '../../../components/pagination';
import Vehicles from '../../../services/vehicles'
import Contact from '../../../services/contracts'
import Tag from '../../../services/tag'
import ModalAggregate from './modal/modal-aggregate-register.vue';
import ModalBlockVehicle from './modal/modal-block-vehicle.vue'

export default {
  data() {
    return {
      page: new Page().size(10),
      loading: false,
      plate: undefined,
      state: 'LOADING',
      filter: '',
      errorMessage: undefined,
      data: [],
      vehicleToBlock: false,
      reasonBlock: '',
      showModalAggregate: false,
      vpSelected: undefined,
      typeAggregate: undefined,
    }
  },
  computed: {
    contractId() {
      return this.$route.params.contractId;
    },
    async contract() {
      return await Contact.getContractByContractId(this.contractId);
    },
    moveMaisId() {
      return this.$route.params.moveMaisId;
    }
  },
  mounted() {
    this.find();
  },
  
  methods: {
    setCurrentPage(p) {
      this.page = this.page.page(p);
      this.find();
    },
    setPageSize(size) {
      this.page = this.page.size(size);
      this.find();
    },
    async modalAggregate(value) {
      this.contractAggregate = await this.contract;
      this.contractAggregate.moveMaisId = this.moveMaisId;
      this.showModalAggregate = true;
      this.$nextTick(() => {
        $('#modal-aggregate').modal();
      });
    },
    find(clearCache) {
      this.state = 'LOADING';
      this.errorMessage = '';

      let filter = {
        contractIdAgr: this.contractId,
        page: this.page.build()
      };

      if(clearCache) {
        this.data = {};
        filterVP.page = 1;
        this.pageSm = filterVP.page = this.pageSm.page(1);
      }

      this.loading = Vehicles.getVehiclesAggregate(filter)
        .then(data => {
          this.data = data.itens;
          if (this.data) {
            this.state = this.data.itens && 'LOADED' || 'NOTFOUND';
            this.page = this.page.itemCount(data.total);
          }
        })
        .catch(err => {
          this.state = 'NOTFOUND';
          this.errorMessage = err.data && err.data.status && err.data.status.message || "Erro do servidor.";
          this.data = err.data;
        });
    },
    search() {
      this.state = 'LOADING';
      this.errorMessage = '';
      let regex = /^[a-zA-Z0-9]{3}\-?[a-zA-Z0-9]{4}$/;
      let promise;
      if (this.plate == '') {
        this.find();
        return;
      } else if (regex.test(this.plate)) {
        promise = Vehicles.getVehicle({'plate': this.plate, 'contractId': this.contractId});
      }
      this.loading = promise
        .then(data => {
          if (data) {
            this.data = data.itens;
            this.state = this.data && this.data && 'LOADED' || 'NOTFOUND';
          }
        })
        .catch(err => {
          this.state = 'NOTFOUND';
          this.errorMessage = err.data && err.data.status && err.data.status.message || "Erro do servidor.";
          this.data = err.data;
        })
    },
    showBlock(vehicle) {
      if (vehicle.reasonBlockId == 0){
        return true;
      }

      return false;
    },
    showUnblock(vehicle) {
      if (vehicle.reasonId == 8)
        return true;

      return false;
    },
    showReplace(vehicle) {
      if (vehicle.tagSerialNumber && (vehicle.requestReplaceTag == 'N'||!vehicle.requestReplaceTag))
        return true;
      return false;
    },
    cancelar() {
      this.vehicleToBlock = false;
      this.reasonBlock = '';
    },
    showBlockModal(value) {
      this.vehicleToBlock = true;
      this.vpSelected = value;
      this.$nextTick(() => {
        $('#modal-block-vehicle').modal();
      });
    },
    showDeleteModal(value) {
      this.vehicleToBlock = true;
      this.typeAggregate = 'delete'
      this.vpSelected = value;
      this.$nextTick(() => {
        $('#modal-block-vehicle').modal();
      });
    },
    close(fn) {
      $('#modal-rescue-balance').modal('hide');
      this.vehicleToBlock = false;
      this.vpSelected = undefined;
      this.type = undefined;
      this.find();
    },
  },
  components: {
    Pagination, ModalAggregate, ModalBlockVehicle
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/aggregate/aggregate-list.js